import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isTokenExist } from "utils/cookies";
import { setCrmIsoSetting } from "appredux/configSlice";
import { crmIsoSettingSelector } from "appredux/selectors";
import { useOptionByName } from "queries/option";
import {
  CRM_ISO_SETTING_KEY,
  isCrmIsoEndpointAllowed,
  parseCrmIsoSetting,
} from "components/apps/settings/CrmIsoSetting/helper";

/**
 * Ambil /options/crm_iso_setting lalu simpan ke redux `app.crm_iso_setting`
 * (field terpisah, tidak ikut ketimpa `setApp` dari inits).
 *
 * Gate `enabled` = token + endpoint diizinkan + crm_iso BELUM ada di redux
 * (`crmIsoSetting === null`). Sengaja TIDAK bergantung `loadedInit`: kita mau
 * fetch kapan pun datanya belum ada (mis. setelah pilih company / reset redux),
 * apa pun timing inits — supaya tidak ada kasus "crm_iso tak pernah ke-fetch"
 * yang membuat boot gate (crmIsoReadySelector) macet loading selamanya.
 *
 * Begitu berhasil (atau gagal → default), crmIsoSetting jadi non-null → enabled
 * false → berhenti. Saat ganti company, resetData mengosongkan field ini → null
 * lagi → otomatis re-fetch untuk company baru.
 */
const useLoadCrmIsoSetting = () => {
  const dispatch = useDispatch();
  const tokenExist = isTokenExist();
  const crmIsoSetting = useSelector(crmIsoSettingSelector);
  const enabled =
    tokenExist && isCrmIsoEndpointAllowed() && crmIsoSetting === null;

  const { data, isError } = useOptionByName(CRM_ISO_SETTING_KEY, {
    enabled,
    throwOnError: false,
  });

  useEffect(() => {
    if (data !== undefined) {
      dispatch(setCrmIsoSetting(parseCrmIsoSetting(data)));
    } else if (isError) {
      // Gagal load → set default (fitur off) supaya boot gate tidak macet.
      dispatch(setCrmIsoSetting(parseCrmIsoSetting(null)));
    }
  }, [data, isError, dispatch]);
};

export default useLoadCrmIsoSetting;
